// ============================================
// Path: /frontend/src/hooks/useNotification.js
// Purpose: Custom hook for notification management (wraps useToast)
// ============================================

import { useToast } from './useToast';
import { useCallback } from 'react';

export const useNotification = () => {
  console.log('🔔 [useNotification] Hook initialized');

  const { toast } = useToast();

  // ========================================
  // SUCCESS NOTIFICATION
  // ========================================
  const showSuccess = useCallback((title, description) => {
    console.log('✅ [useNotification] Success:', title);
    toast({
      title,
      description,
    });
  }, [toast]);

  // ========================================
  // ERROR NOTIFICATION
  // ========================================
  const showError = useCallback((title, description) => {
    console.error('❌ [useNotification] Error:', title);
    toast({
      variant: 'destructive',
      title,
      description,
    });
  }, [toast]);

  // ========================================
  // INFO NOTIFICATION
  // ========================================
  const showInfo = useCallback((title, description) => {
    console.log('ℹ️ [useNotification] Info:', title);
    toast({
      title,
      description,
    });
  }, [toast]);

  // ========================================
  // WARNING NOTIFICATION
  // ========================================
  const showWarning = useCallback((title, description) => {
    console.warn('⚠️ [useNotification] Warning:', title);
    toast({
      variant: 'destructive',
      title,
      description,
    });
  }, [toast]);

  return {
    showSuccess,
    showError,
    showInfo,
    showWarning,
    toast, // Expose raw toast for custom use
  };
};